module.exports = __webpack_public_path__ + "static/media/VoidDrift.92d2c2fb.mp4";